import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../utils/axiosBaseQuery";
import {
  GET_PRODUCT_BANNER,
  UPDATE_PRODUCT_BANNER,
  ADD_PRODUCT_BANNER,
  DELETE_PRODUCT_BANNER,
} from "../../config/constants";

const productBannerApi = createApi({
  reducerPath: "productSettingsService",
  baseQuery: axiosBaseQuery({ baseUrl: "" }),
  tagTypes: ["ProductSettings"],
  endpoints: (builder) => ({
    getProductBanner: builder.query({
      query: () => ({
        url: GET_PRODUCT_BANNER,
        method: "GET",
      }),
      providesTags: ["ProductSettings"],
      keepUnusedDataFor: 0,
    }),
    updateProductBanner: builder.mutation({
      query: ({ updatedData, id }) => ({
        url: UPDATE_PRODUCT_BANNER + `/${id}`,
        method: "PUT",
        data: updatedData,
      }),
      // invalidatesTags: ["ProductSettings"],
    }),
    addProductBanner: builder.mutation({
      query: (newData) => ({
        url: ADD_PRODUCT_BANNER,
        method: "POST",
        data: newData,
      }),
      invalidatesTags: ["ProductSettings"],
    }),
    deleteProductBanner: builder.mutation({
      query: (id) => ({
        url: `${DELETE_PRODUCT_BANNER}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["ProductSettings"],
    }),
  }),
});

export const {
  // useGetProductSettingsQuery
  useGetProductBannerQuery,
  useUpdateProductBannerMutation,
  useAddProductBannerMutation,
  useDeleteProductBannerMutation,
} = productBannerApi;

export default productBannerApi;
